import "./components/jquery-ui/jquery-ui.min";
import $ from "jquery";
// import "slick-carousel";
import "./components/slick-init";
// import "./components/swiffy-init";
import "./components/buttons";
import "./components/buttons-editor";
import "./components/wp-video";
import "./components/accordions";
import "./helpers/acf-map";
import "./components/pinehurst";
import "./components/grid-cards";
import "./components/ubermenu";
//import "./components/revinate";
import "./components/forms";
import "./components/rates";
// import "../map/assets/js/map";

// import "./components/navigation";
// import "./components/social-feed";
// import "./components/accordions";
// import "./helpers/parallax";
